module.exports = __webpack_public_path__ + "static/img/user.d66bdaeb.svg";